import { Text } from '@change/ds-core-ui/next';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

export function LoadingMessage() {
	return (
		<div
			data-testqa="loading-message"
			data-testid="loading-message"
			className="flex flex-col items-center justify-center gap-3 p-2 text-center"
			aria-label="Loading data"
		>
			<Loader />
			<Text size="xx-small" variant="heading">
				Your custom Facebook post is still generating. This may take a few seconds.
			</Text>
		</div>
	);
}
